import {Component, EventEmitter, Input, Output} from '@angular/core';
import {WorkspaceHighlightVm} from '../../models/team-dynamic.vm';

@Component({
  selector: 'app-highlights',
  templateUrl: './highlights.component.html',
  styleUrls: ['./highlights.component.scss']
})
export class HighlightsComponent {
  @Input() highlights: WorkspaceHighlightVm[] = [];
  @Input() titleKey: string = 'td_workspace_insights';

  @Output() dismissed = new EventEmitter<WorkspaceHighlightVm>();

  onDismiss(highlight: WorkspaceHighlightVm) {
    this.dismissed.emit(highlight);
  }

  trackByUuid(index: number, highlight: WorkspaceHighlightVm) {
    return highlight.uuid ?? index;
  }
}
